import * as API from '@user/api';
import { actionDebug as debug } from '@user/util/debuggers';

export const actions = {
  update(context, { formularIdentifier, formData }) {
    debug('FORMS/update', formularIdentifier, formData);
    context.commit('UPDATE', { formularIdentifier, formData });
  },

  clear(context, formularIdentifier) {
    context.commit('CLEAR', formularIdentifier);
  },

  async submit(_context, options) {
    debug('FORMS/submit %o', options);

    const { formularIdentifier, payload } = options;
    try {
      await API.submitForm(formularIdentifier, payload);
      return { status: 'success' };
    } catch (e) {
      return { status: 'failure', error: e };
    }
  },

  async customSubmit(_context, options) {
    const { url, payload } = options;
    try {
      await API.customSubmit(url, payload);
      return { status: 'success' };
    } catch (e) {
      return { status: 'failure' };
    }
  },

  getFormData(_context, formularIdentifier) {
    return API.loadFormData(formularIdentifier);
  },
};
